<template>
    <table-template :queryParams="queryParams" actionUrl="/dbtCard/findObdUserOrders.action" ref="transaction-records">
        <template slot="search">
            <el-select @change="$refs['transaction-records'].search()" clearable placeholder="请选择状态"
                       v-model="queryParams.payStatus">
                <el-option :value="1" label="待支付"></el-option>
                <el-option :value="2" label="支付成功"></el-option>
                <el-option :value="3" label="支付失败"></el-option>
                <el-option :value="4" label="支付关闭"></el-option>
                <el-option :value="5" label="转入退款"></el-option>
                <el-option :value="6" label="取消支付"></el-option>
                <el-option :value="7" label="支付中"></el-option>
            </el-select>

            <el-select @change="$refs['transaction-records'].search()" clearable placeholder="安装状态"
                       v-model="queryParams.installStatus">
                <el-option :value="1" label="已安装"></el-option>
                <el-option :value="2" label="未安装"></el-option>
            </el-select>

            <el-date-picker
                    @change="onPayTimeChanged"
                    clearable
                    end-placeholder="支付时间截止"
                    range-separator="至"
                    start-placeholder="支付时间开始"
                    style="margin-left: 10px;"
                    type="datetimerange"
                    v-model="payTimeSearch">
            </el-date-picker>

            <el-date-picker
                    @change="onCreateTimeChanged"
                    clearable
                    end-placeholder="创建时间截止"
                    range-separator="至"
                    start-placeholder="创建时间开始"
                    style="margin-left: 10px;"
                    type="datetimerange"
                    v-model="createTimeSearch">
            </el-date-picker>

            <el-input placeholder="昵称/手机号/订单号/安装点" style="margin-left: 10px;width: 200px;"
                      v-model="queryParams.keyword"></el-input>
            <el-button @click="$refs['transaction-records'].search()" style="margin-left: 10px;" type="primary">搜索
            </el-button>
        </template>
        <template slot="item">
            <el-table-column
                    label="订单号"
                    prop="orderNumber">
            </el-table-column>
            <el-table-column
                    label="昵称"
                    prop="personName">
            </el-table-column>
            <el-table-column
                    label="账号"
                    prop="personPhone">
            </el-table-column>
            <el-table-column
                    label="交易金额">
                <template scope="scope">
                    <span  v-if="scope.row.totalMoney > 0 ">
                        {{scope.row.totalMoney}}
                    </span>
                    <span style="color:red;" v-else>
                        {{scope.row.totalMoney}}
                    </span> 元
                </template>
            </el-table-column>
            <el-table-column
                    label="状态">
                <template scope="scope">
                    <span v-bind:style="{color:getPayStatusColor(scope.row.payStatus)}">{{scope.row.payStatus | payStatusFilter}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    label="支付时间">
                <template scope="scope">
                    {{scope.row.payTime | dateTimeFormat}}
                </template>
            </el-table-column>

            <el-table-column
                    label="类型">
                <template scope="scope">
                    <el-tag type="info" v-if="scope.row.type == 1 "> 线上购买</el-tag>
                    <el-tag type="danger" v-if="scope.row.type == 2">线下购买</el-tag>
                </template>
            </el-table-column>

            <el-table-column
                    label="安装状态">
                <template scope="scope">
                    <span style="color:#00CC00;" v-if="scope.row.sn"> 已安装 </span>
                    <span style="color:#FF9900;" v-else> 未安装 </span>
                </template>
            </el-table-column>

            <el-table-column
                    label="安装时间">
                <template scope="scope">
                    {{scope.row.deviceTime | dateTimeFormat}}
                </template>
            </el-table-column>
            <el-table-column
                    label="绑定设备SN">
                <template scope="scope">
                    {{scope.row.sn}}
                </template>
            </el-table-column>
            <el-table-column
                    label="安装点">
                <template scope="scope">
                    {{scope.row.businessName}}
                </template>
            </el-table-column>

            <el-table-column
                    label="创建时间">
                <template scope="scope">
                    {{scope.row.createTime | dateTimeFormat}}
                </template>
            </el-table-column>
        </template>
    </table-template>
</template>
<script>
import TableTemplate from '@/components/TableTemplate'

export default {
  name: 'opening-card-record',
  data () {
    return {
      createTimeSearch: null,
      payTimeSearch: null,
      queryParams: {}
    }
  },
  components: { TableTemplate },
  filters: {
    goodsTypeFilter (value) {
      let filterValue = '暂无'
      switch (value) {
        case 1:// 开通会员
          filterValue = '开通会员'
          break
        case 2:// 会员续费
          filterValue = '会员续费'
          break
        case 3:// 购买权益卡礼包
          filterValue = '购买云服务包'
          break
        case 4:// 续补权益卡
          filterValue = '购买云服务'
          break
        case 5:// 维保查询
          filterValue = '维保查询'
          break
        case 6:// 碰撞查询
          filterValue = '碰撞查询'
          break
        case 7:// 商品活动
          filterValue = '商品活动'
          break
        case 8:// 商品活动
          filterValue = '省心智联'
          break
      }
      return filterValue
    },
    payStatusFilter (value) {
      let filterValue = '暂无'
      switch (value) {
        case 1:// 待支付
          filterValue = '待支付'
          break
        case 2:// 支付成功
          filterValue = '支付成功'
          break
        case 3:// 支付失败
          filterValue = '支付失败'
          break
        case 4:// 支付关闭
          filterValue = '支付关闭'
          break
        case 5:// 转入退款
          filterValue = '转入退款'
          break
        case 6:// 取消支付
          filterValue = '取消支付'
          break
        case 7:// 支付中（用户唤起支付）
          filterValue = '支付中'
          break
      }
      return filterValue
    }
  },
  methods: {
    onPayTimeChanged (datetime) {
      if (!datetime || datetime[0] == null) {
        this.queryParams.payTimeSearchStart = null
        this.queryParams.payTimeSearchEnd = null
        this.$refs['transaction-records'].search()
        return
      }
      this.queryParams.payTimeSearchStart = datetime[0].getTime()
      this.queryParams.payTimeSearchEnd = datetime[1].getTime()
      this.$refs['transaction-records'].search()
    },
    onCreateTimeChanged (datetime) {
      if (!datetime || datetime[0] == null) {
        this.queryParams.createTimeSearchStart = null
        this.queryParams.createTimeSearchEnd = null
        this.$refs['transaction-records'].search()
        return
      }
      this.queryParams.createTimeSearchStart = datetime[0].getTime()
      this.queryParams.createTimeSearchEnd = datetime[1].getTime()
      this.$refs['transaction-records'].search()
    },
    getPayStatusColor (status) {
      let color = ''
      switch (status) {
        case 3:// 1-支付失败
        case 4:// 支付关闭
        case 5:// 转入退款
        case 6:// 取消支付
          color = '#F56C6C'
          break
        case 2:// 审核通过
          color = '#00CC00'
          break
        default:// 2-待支付;
          color = '#E6A23C'
      }
      return color
    }
  }
}
</script>
